import React from "react";
import { Link } from "react-router-dom";
import { SheetClose } from "../ui/sheet";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { wooCategory } from "@/src/lib/interfaces";

export default function BrandsDrawer({
  categories,
}: {
  categories: wooCategory[];
}) {
  return (
    <AccordionItem
      value={"BRANDS"}
      key={"brands"}
      className={`border-b-0 data-[state=open]:border-b-0`}
    >
      <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
        <SheetClose
          asChild
          className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
        >
          <Link to={`/shop/category/486/BRANDS`}>
            {"BRANDS"}
          </Link>
        </SheetClose>
      </AccordionTrigger>
      <AccordionContent className="mt-5 pb-0 pl-5 text-[12px]">
        <Accordion
          type="single"
          collapsible
          className="w-full flex flex-col gap-5"
        >
          {categories
            ?.filter(
              (cat) => cat.id === 368 || cat.id === 502
            )
            .map((category) => (
              <AccordionItem
                key={category.id}
                value={category.name}
                className={`border-b-0 data-[state=open]:border-b-0`}
              >
                <AccordionTrigger className="hover:no-underline hover:text-neutral-500 p-0 font-light">
                  <SheetClose
                    asChild
                    className={`hover:underline cursor-pointer items-center w-fit`}
                  >
                    <Link
                      to={`/shop/category/${category.id}/${category.name}`}
                    >
                      {category.name}
                    </Link>
                  </SheetClose>
                </AccordionTrigger>

                <AccordionContent className="p-2 mt-3 flex flex-col gap-3">
                  {categories
                    ?.filter(
                      (sub) => sub.parent === category.id
                    )
                    .map((cat: any) => (
                      <SheetClose
                        asChild
                        key={cat.id}
                        className={`flex justify-between hover:underline cursor-pointer items-center font-montserrat w-fit`}
                      >
                        <Link
                          to={`/shop/category/${cat.id}/${cat.name}`}
                          className="text-[12px] font-light cursor-pointer hover:text-neutral-600 "
                        >
                          {cat.name}
                        </Link>
                      </SheetClose>
                    ))}
                </AccordionContent>
              </AccordionItem>
            ))}
        </Accordion>
      </AccordionContent>
    </AccordionItem>
  );
}
